import { Eye, Layers, FlaskConical, Bot, BarChart3, TrendingUp, Zap, Target, Shield, Brain, Workflow, LineChart, Search, FileText, Users, Settings } from "lucide-react";

export type FeatureSlug = "ai-visibility" | "topic-clustering" | "prompt-testing" | "agentic-ops";

export const featureSlugs: FeatureSlug[] = ["ai-visibility", "topic-clustering", "prompt-testing", "agentic-ops"];

export const features: Record<FeatureSlug, {
  icon: typeof Eye;
  heroIcon: typeof Eye;
  capabilities: { icon: typeof Eye }[];
}> = {
  "ai-visibility": {
    icon: Eye,
    heroIcon: Eye,
    capabilities: [
      { icon: BarChart3 },
      { icon: TrendingUp },
      { icon: LineChart },
      { icon: Search },
      { icon: Shield },
      { icon: Target },
    ],
  },
  "topic-clustering": {
    icon: Layers,
    heroIcon: Layers,
    capabilities: [
      { icon: Brain },
      { icon: Target },
      { icon: Layers },
      { icon: TrendingUp },
      { icon: FileText },
      { icon: BarChart3 },
    ],
  },
  "prompt-testing": {
    icon: FlaskConical,
    heroIcon: FlaskConical,
    capabilities: [
      { icon: FlaskConical },
      { icon: Users },
      { icon: BarChart3 },
      { icon: Search },
      { icon: Zap },
      { icon: LineChart },
    ],
  },
  "agentic-ops": {
    icon: Bot,
    heroIcon: Bot,
    capabilities: [
      { icon: Workflow },
      { icon: Bot },
      { icon: Shield },
      { icon: Settings },
      { icon: Zap },
      { icon: BarChart3 },
    ],
  },
};
